var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box, InfoCircleIcon, Toggle, TOGGLE_STATES, Tooltip, TooltipTrigger, Trans, translate, Typography, useModal, useTooltip, } from '@lucidlink/uicore';
import { SpecialCharacters } from '../../../SpecialCharacters';
export const AllowSpecialCharacters = ({ data, }) => {
    _react_refresh_temp_2();
    const { value } = data;
    const isRestricted = Boolean(Number(value));
    const { anchorRef, isTooltipActive, tooltipProps, triggerProps } = useTooltip({
        placement: 'right',
    });
    const { closeModal, openModal } = useModal({
        closeOnUnmount: true,
    });
    const onRestrictSpecialCharactersClick = useCallback(() => {
        openModal({
            content: (_jsx(SpecialCharacters, { closeModal: closeModal, shouldAllow: isRestricted })),
        });
    }, [closeModal, isRestricted, openModal]);
    const symbols = '\\/:*?"<>|,';
    return (_jsxs(Box, { align: "center", isFullWidth: true, justify: "between", width: "sm", children: [_jsxs(TooltipTrigger, { triggerProps: triggerProps, children: [_jsxs(Box, { align: "center", gap: "s", children: [_jsx(Typography, { color: "accent", kind: "label", children: _jsx(Trans, { children: "Allow special characters" }) }), _jsx(InfoCircleIcon, { ref: anchorRef, size: "small" })] }), isTooltipActive && (_jsx(Tooltip, { contents: [
                            translate('Forbid or allow creating files or folders with names which are not compatible with Windows. These are names containing any of the following special characters: {{symbols}} have a trailing space or dot, or represent a reserved name on Windows.', { symbols }),
                        ], tooltipProps: tooltipProps }))] }), _jsx(Toggle, { ariaLabel: translate('Allow special characters'), "data-testid": "restrict-special-characters", onClick: onRestrictSpecialCharactersClick, state: !isRestricted ? TOGGLE_STATES.ON : TOGGLE_STATES.OFF })] }));
};
_react_refresh_temp_1 = AllowSpecialCharacters;
$RefreshReg$(_react_refresh_temp_1, "AllowSpecialCharacters");
_react_refresh_temp_2(AllowSpecialCharacters, "LSMFRtjanopiuJxJvp/on1BNSUY=", false, () => [useTooltip, useModal]);
